var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84763 3.98398C6.77132 6.08409 4.20338 6.08529 4.125 3.98398C4.12706 3.10916 4.73552 2.4011 5.48632 2.3999C6.23814 2.3999 6.84763 3.10916 6.84763 3.98398Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9262 3.74508C7.37125 -1.25604 3.61021 -1.24067 0.0738176 3.74508C-0.0246059 3.88944 -0.0246059 4.11055 0.0738176 4.25487C3.61948 9.26525 7.39557 9.23147 10.9262 4.25487C11.0246 4.11055 11.0246 3.88944 10.9262 3.74508ZM5.49768 6.70557C4.33509 6.704 3.39252 5.45411 3.39021 3.91246C3.50716 0.204227 7.49052 0.205764 7.60516 3.91246C7.604 5.45411 6.66143 6.70557 5.49768 6.70557Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeicon);
export default __webpack_public_path__ + "static/media/eyeicon.31aa66ae87371f3bc2507289db026c28.svg";
export { ForwardRef as ReactComponent };